import { createStyles, Theme } from '@material-ui/core'

export const styles = (theme: Theme) =>
  createStyles({
    card: {
      margin: theme.spacing(2)
    }
  })
